import {Routes} from '@angular/router';
import {UserSearchPageComponent} from './user-search-page.component';

/**
 * Created by Rodrigo Quesada on 16/03/17.
 */
const routes: Routes = [{path: 'search/users', component: UserSearchPageComponent}];
export default routes;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/admin/search/user-search-page.routing.ts